import { Injectable } from '@angular/core';
import {
    CanActivate,
    CanMatch,
    Route,
    Router,
    UrlSegment,
    UrlTree,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
} from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanMatch {
    constructor(private _authService: AuthService, private _router: Router) {}

    /**
     * Can activate
     */
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        const redirectUrl = state.url === '/sign-in' ? '/parking' : '/sign-in';
        return this._check(redirectUrl);
    }

    /**
     * Can match
     */
    canMatch(
        route: Route,
        segments: UrlSegment[]
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return this._check('/sign-in');
    }

    /**
     * Check the authenticated status
     */
    private _check(redirectURL: string): Observable<boolean | UrlTree> {
        return this._authService.check().pipe(
            switchMap((authenticated) => {
                // console.log('AuthGuard: Authenticated?', authenticated);

                // Jika TIDAK authenticated (belum login)
                if (!authenticated) {
                    // console.log(
                    //     'AuthGuard: User not authenticated, redirecting to sign-in'
                    // );
                    return of(this._router.createUrlTree(['/sign-in']));
                }

                // Jika sudah login, allow access
                // console.log('AuthGuard: User authenticated, allowing access');
                return of(true);
            })
        );
    }
}
